// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d3fdf53e","239":"795efaa6","732":"2a9e950d"}[chunkId] + ".chunk.js";
};